// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"j2","logoWrapper":"j3"};